const actionPrefix = 'SKAFTE/COMMERCE/';

export const WATER_ADD_TO_BUCKET = `${actionPrefix}WATER_ADD_TO_BUCKET`;

export const addWaterToBucket = payload => ({
  type: WATER_ADD_TO_BUCKET,
  payload,
});
